import { ITestableComponentProps } from "../../../shared/types/testing.types";

export interface IPageHeadingProps extends ITestableComponentProps {
  title?: string | null;
}

export const DefaultPageHeadingProps = {
  title: "Project Dashboard",
};
